import axios from "axios";
import store from "../../store/index";
import moment from "moment";
import VPagination from "@hennge/vue3-pagination";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";
import ShellModal from "../shells/ShellModal.vue";
import ShellPreview from "../shells/ShellPreview.vue";

export default {
  name: "shells",
  components: {
    VPagination,
    ShellModal,
    ShellPreview,
  },
  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      showShellLoading: false,
      showShellModal: false,
      showShellPreview: false,
      editingShellId: null,
      currentPageNumber: 1,
      showActionPopup: [],
      totalPages: 0,
      hasError: false,
      SortOrder: 0,
      SortProperty: "TemplateName",
      ShellList: [],
      defaultdate: "",
      ReportList: [],
      selectedReportId: "",
      ProgramList: [],
      selectedProgramId: "",
      HeadingList: [],
      selectedHeadingId: "",
      RawTocData: [],
      nextVersionData: null,
    };
  },

  computed: {
    selectedStudyId() {
      return store.getters.getStudyIs;
    },
    shellsPageLevel() {
      if (this.ShellList && this.ShellList.length > 0) {
        const firstShell = this.ShellList[0];
        const programId = this.getShellProgramId(firstShell);
        const reportId = this.getShellReportId(firstShell);
        if (programId) {
          return 'program';
        } else if (reportId) {
          return 'report';
        } else {
          return 'study';
        }
      }
      if (this.selectedProgramId) {
        return 'program';
      } else if (this.selectedReportId) {
        return 'report';
      } else {
        return 'study';
      }
    }
  },

  watch: {
    selectedStudyId: {
      immediate: true,
      async handler(newVal, oldVal) {
        console.log("[Shells] Study changed:", oldVal, "→", newVal);
        if (newVal && newVal !== oldVal) {
          this.applyRouteReportSelection();
          await this.GetReportList();
          await this.GetShellList();
        }
      },
    },
    "$route.query.reportId": {
      async handler() {
        if (this.getRouteReportId()) {
          this.applyRouteReportSelection();
        } else {
          this.selectedReportId = "";
          if (!this.getRouteProgramId()) {
            this.selectedProgramId = "";
          }
          this.selectedHeadingId = "";
        }
        if (this.selectedStudyId) {
          await this.GetReportList();
          await this.GetShellList();
        }
      },
    },
    "$route.query.programId": {
      async handler() {
        if (this.selectedStudyId) {
          await this.GetReportList();
          await this.GetShellList();
        }
      },
    },
  },

  async mounted() {
    this.defaultdate = localStorage.getItem("dateformat");
    console.log("[Shells] mounted, studyId =", store.getters.getStudyIs);
    document.addEventListener("click", this.handleOutsideClick);
  },

  beforeUnmount() {
    document.removeEventListener("click", this.handleOutsideClick);
  },

  methods: {
    getRouteReportId() {
      const reportId = this.$route && this.$route.query
        ? this.$route.query.reportId
        : "";
      return Array.isArray(reportId) ? reportId[0] : reportId || "";
    },

    getRouteProgramId() {
      const programId = this.$route && this.$route.query
        ? this.$route.query.programId
        : "";
      return Array.isArray(programId) ? programId[0] : programId || "";
    },

    normalizeId(id) {
      if (
        id === null ||
        id === undefined ||
        String(id).trim().toLowerCase() === "null" ||
        String(id).trim().toLowerCase() === "undefined"
      ) {
        return "";
      }
      return String(id);
    },

    applyRouteReportSelection() {
      const routeReportId = this.getRouteReportId();
      if (!routeReportId) return false;

      this.selectedReportId = routeReportId;

      const heading = this.RawTocData.find(function(item) {
        return (item.Reports || []).some(function(report) {
          return (
            report.Reportid === routeReportId ||
            report.ReportId === routeReportId ||
            report.reportId === routeReportId
          );
        });
      });

      if (heading) {
        this.selectedHeadingId = heading.Headingid;
      }

      return true;
    },

    applyRouteProgramSelection() {
      const routeProgramId = this.normalizeId(this.getRouteProgramId());
      if (!routeProgramId) return false;

      const programExists = this.ProgramList.some(function(program) {
        return String(program.ProgramId) === routeProgramId;
      });

      if (programExists) {
        this.selectedProgramId = routeProgramId;
        return true;
      }

      return false;
    },

    normalizeShellList(data) {
      const shellData = data && data.data !== undefined
        ? data.data
        : data && data.result !== undefined
          ? data.result
          : data;
      if (Array.isArray(shellData)) return shellData;
      if (shellData && shellData._id) return [shellData];
      return [];
    },

    getShellReportId(shell) {
      const reportId = shell ? shell.ReportId || shell.Reportid || shell.reportId || "" : "";
      if (
        reportId === null ||
        reportId === undefined ||
        String(reportId).trim().toLowerCase() === "null" ||
        String(reportId).trim().toLowerCase() === "undefined"
      ) {
        return "";
      }
      return reportId;
    },

    getShellProgramId(shell) {
      const programId = shell
        ? shell.ProgramId ||
          shell.Programid ||
          shell.ProgramID ||
          shell.programId ||
          shell.programid ||
          shell.program_id ||
          shell.ProgrammeId ||
          shell.programmeId ||
          shell.SourceId ||
          shell.sourceid ||
          ""
        : "";
      return this.normalizeId(programId);
    },

    filter(shell) {
      const date = shell.CreatedAt || shell.LastModifiedAt || null;
      if (date) return moment(date).format(this.defaultdate);
      return "—";
    },

    async GetShellList() {
      const idtoken = store.getters.getIdToken;
      const studyId = store.getters.getStudyIs;

      if (!studyId) {
        console.warn("[Shells] studyId is empty — skipping API call");
        return;
      }

      this.showShellLoading = true;
      this.hasError = false;
      this.ShellList = [];
      this.showActionPopup = [];

      let url;
      if (this.selectedProgramId) {
        url = `${this.baseurl}/stats-python/shellconfig/program-list/${studyId}/${this.selectedProgramId}`;
      } else if (this.selectedReportId) {
        url = `${this.baseurl}/stats-python/shellconfig/report-list/${studyId}/${this.selectedReportId}`;
      } else {
        url = `${this.baseurl}/stats-python/shellconfig/study/${studyId}`;
      }

      console.log("[Shells] Calling:", url);

      try {
        let res;
        try {
          res = await axios.get(url, {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          });
        } catch (err) {
          if ((this.selectedReportId || this.selectedProgramId) && err.response && err.response.status === 404) {
            console.log("[Shells] Config not found (404), preparing to clone...");
            res = { data: [] };
          } else {
            throw err;
          }
        }

        let shellList = this.normalizeShellList(res.data);
        console.log("[Shells] Raw API response count:", Array.isArray(shellList) ? shellList.length : (shellList ? 1 : 0));
        // Normalize fields returned by backend to consistent names
        shellList = shellList.map(s => {
          const normalized = { ...s };
          normalized.IsDefault = s.IsDefault || s.Isdefault || s.isDefault || false;
          normalized._id = s._id || s.id || s._id || s.ID || s.IDs || s._id;
          return normalized;
        });
        if (!this.selectedReportId && !this.selectedProgramId) {
          shellList = shellList.filter(shell => !this.getShellReportId(shell));
        }
        if (this.selectedReportId && !this.selectedProgramId) {
          shellList = shellList.filter(shell => !this.getShellProgramId(shell));
        }

        if (this.selectedProgramId && shellList.length === 0) {
          console.log("[Shells] No shells found for program. Cloning from report...");
          // const cloneUrl = `${this.baseurl}/stats-python/shellconfig/program/${this.selectedProgramId}/clone-from-report?study_id=${studyId}&report_id=${this.selectedReportId || ""}`;
          // try {
          //   await axios.post(cloneUrl, {
          //     StudyId: studyId,
          //     ReportId: this.selectedReportId || null,
          //     ProgramId: this.selectedProgramId,
          //   }, {
          //     headers: {
          //       Authorization: "Bearer " + idtoken,
          //       "Content-Type": "application/json",
          //     },
          //   });
          //   console.log("[Shells] Clone successful, retrying fetch from program-list...");
          // } catch (cloneErr) {
          //   console.error("[Shells] Clone failed:", cloneErr.response?.data || cloneErr.message);
          // }
          // const retryRes = await axios.get(url, {
          //   headers: {
          //     Authorization: "Bearer " + idtoken,
          //     "Content-Type": "application/json",
          //   },
          // });
          // shellList = this.normalizeShellList(retryRes.data);
          // console.log("[Shells] After clone retry, shells count:", Array.isArray(shellList) ? shellList.length : 1, 
          //   shellList.length > 0 ? `— first shell ProgramId: ${shellList[0]?.ProgramId}` : "");
        }

        // if (this.selectedReportId && !this.selectedProgramId && shellList.length === 0) {
        //   console.log("[Shells] No shells found for report. Cloning from study...");
        //   const cloneUrl = `${this.baseurl}/stats-python/shellconfig/report/${this.selectedReportId}/clone-from-study?study_id=${studyId}`;
        //   await axios.post(cloneUrl, {}, {
        //     headers: {
        //       Authorization: "Bearer " + idtoken,
        //       "Content-Type": "application/json",
        //     },
        //   });
        //   const retryRes = await axios.get(url, {
        //     headers: {
        //       Authorization: "Bearer " + idtoken,
        //       "Content-Type": "application/json",
        //     },
        //   });
        //   shellList = this.normalizeShellList(retryRes.data);
        // }

        this.ShellList = shellList;

        if (this.ShellList.length === 0 && !this.selectedReportId && !this.selectedProgramId) {
          console.log("[Shells] No shells found for study → showing Import button");
          this.hasError = true;
        } else {
          this.hasError = false;
        }

        this.showActionPopup = this.ShellList.map(() => false);
      } catch (err) {
        console.error("[Shells] API error:", err.response?.status, err.response?.data || err.message);
        this.hasError = true;
        this.ShellList = [];
      } finally {
        this.showShellLoading = false;
      }
    },

    async GetReportList() {
      const idtoken = store.getters.getIdToken;
      const studyId = store.getters.getStudyIs;
      if (!studyId) return;

      try {
        const res = await axios.post(
          `${this.baseurl}/stats-python/toc/gettocwithprogram`,
          {
            StudyId: studyId,
            TocId: "",
            HeadingName: [],
            HasOutput: null,
            IsSelectedVersion: true,
            ReportId: "",
            ReportName: "",
            Version: "",
            TocDescription: "",
            ReportType: [],
            DeveloperName: [],
            QCName: [],
            Status: "",
            ProgramId: "",
            ProgramName: [],
            HasProgram: null,
            InterimVersion: "",
            Outputstate: null,
          },
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );

        const tocData = res.data?.result?.toc_data || [];
        this.RawTocData = tocData;
        this.HeadingList = tocData.map(h => ({
          Headingid: h.Headingid,
          Headingname: h.Headingname,
        }));
        const hasRouteReport = this.applyRouteReportSelection();
        this.filterReports({ preserveSelectedReport: hasRouteReport });
        this.filterPrograms();
        this.applyRouteProgramSelection();
        console.log("[Shells] Heading list loaded:", this.HeadingList.length, "headings");
      } catch (err) {
        console.error("[Shells] Error fetching report list:", err);
      }
    },

    onHeadingChange() {
      this.selectedReportId = "";
      this.selectedProgramId = "";
      this.filterReports();
      this.filterPrograms();
      this.GetShellList();
    },

    onReportChange() {
      this.selectedProgramId = "";
      this.filterPrograms();
      this.GetShellList();
    },

    onProgramChange() {
      const selectedProgram = this.ProgramList.find(program => (
        String(program.ProgramId) === String(this.selectedProgramId)
      ));

      if (selectedProgram) {
        this.selectedHeadingId = selectedProgram.HeadingId || this.selectedHeadingId;
        this.selectedReportId = selectedProgram.ReportId || this.selectedReportId;
        this.filterReports({ preserveSelectedReport: true });
        this.filterPrograms();
        this.selectedProgramId = selectedProgram.ProgramId;
      }

      this.GetShellList();
    },

    filterReports(options = {}) {
      const preserveSelectedReport = options.preserveSelectedReport === true;

      if (!this.selectedHeadingId) {
        this.ReportList = [];
      } else {
        const heading = this.RawTocData.find(h => h.Headingid === this.selectedHeadingId);
        if (heading && heading.Reports) {
          this.ReportList = heading.Reports.map(report => ({
            Reportid: report.Reportid || report.ReportId || report.reportId,
            Reportname: report.Reportname || "Unnamed Report",
          }));
        } else {
          this.ReportList = [];
        }
      }

      if (
        this.selectedReportId &&
        !preserveSelectedReport &&
        !this.ReportList.find(r => r.Reportid === this.selectedReportId)
      ) {
        this.selectedReportId = "";
        this.GetShellList();
      }
    },

    filterPrograms() {
      const programs = [];
      const selectedReportId = this.normalizeId(this.selectedReportId);

      for (const heading of this.RawTocData) {
        if (this.selectedHeadingId && heading.Headingid !== this.selectedHeadingId) continue;

        for (const report of (heading.Reports || [])) {
          const reportId = this.normalizeId(report.Reportid || report.ReportId || report.reportId);
          if (selectedReportId && reportId !== selectedReportId) continue;

          const subindex = report.Subindex || "";
          (report.Programms || []).forEach((program, programIndex) => {
            const programId = this.normalizeId(
              program.SourceId ||
              program._id ||
              program.ProgramId ||
              program.Programid ||
              program.PreviousId ||
              ""
            );
            if (!programId) return;

            const reportType = Array.isArray(program.ReportType) && program.ReportType.length > 0
              ? program.ReportType[0]
              : "";
            const baseName = program.ProgramTitle || program.ProgramName || "Unnamed Program";
            const tocNumber = subindex ? `${subindex}.${programIndex + 1}` : `${programIndex + 1}`;
            const programName = reportType
              ? `${reportType} ${tocNumber} ${baseName}`
              : `${tocNumber} ${baseName}`;

            programs.push({
              ProgramId: programId,
              ProgramName: programName,
              ReportId: reportId,
              HeadingId: heading.Headingid,
            });
          });
        }
      }

      this.ProgramList = programs;
    },

    async importDefaultShell() {
      const idtoken = store.getters.getIdToken;
      const studyId = store.getters.getStudyIs;
      if (!confirm("Are you sure you want to import the default shell for this study?")) return;

      try {
        this.showShellLoading = true;
        const response = await axios.get(
          `${this.baseurl}/stats-python/shellconfig/default-template/${studyId}`,
          {
            headers: {
              Authorization: `Bearer ${idtoken}`,
              "Content-Type": "application/json",
            },
          }
        );
        console.log("[Shells] Import response:", response.data);
        alert("Shell imported successfully!");
        await this.GetShellList();
      } catch (error) {
        console.error("[Shells] Import error:", error.response?.data || error);
        alert("Failed to import shell. Please try again.");
      } finally {
        this.showShellLoading = false;
      }
    },

    async deleteShell(id) {
      const idtoken = store.getters.getIdToken;
      if (!confirm("Are you sure you want to delete this shell?")) return;

      try {
        this.showShellLoading = true;
        await axios.delete(`${this.baseurl}/stats-python/shellconfig/${id}`, {
          headers: { Authorization: `Bearer ${idtoken}` },
        });
        alert("Shell deleted successfully.");
        await this.GetShellList();
      } catch (error) {
        console.error("Delete error:", error.response?.data || error);
        alert("Failed to delete shell.");
      } finally {
        this.showShellLoading = false;
        this.showActionPopup = this.ShellList.map(() => false);
      }
    },

    async setAsDefault(shellId) {
      const idtoken = store.getters.getIdToken;

      try {
        this.showShellLoading = true;
        await axios.post(`${this.baseurl}/stats-python/shellconfig/set-default/${shellId}`, {}, {
          headers: { Authorization: `Bearer ${idtoken}` },
        });
        alert("Shell set as default successfully!");
        await this.GetShellList();

        this.showActionPopup = this.ShellList.map(() => false);
      } catch (error) {
        console.error("Set default error:", error.response?.data || error);
        alert("Failed to set as default.");
      } finally {
        this.showShellLoading = false;
        this.showActionPopup = this.ShellList.map(() => false);
      }
    },

  async addNewVersion(shell) {
  const idtoken = store.getters.getIdToken;
  try {
    this.showShellLoading = true;
    const res = await axios.get(
      `${this.baseurl}/stats-python/shellconfig/next-version/${shell._id}`,
      { headers: { Authorization: "Bearer " + idtoken } }
    );

    const nextVersionResponse = res.data.data || res.data;
    this.nextVersionData = {
      Version:
        nextVersionResponse?.Version ||
        nextVersionResponse?.version ||
        nextVersionResponse?.shellVersion ||
        nextVersionResponse?.ShellVersion ||
        nextVersionResponse?.NextVersion ||
        nextVersionResponse?.nextVersion ||
        "",
    };
    console.log(this.nextVersionData);
    
    console.log("[Shells] nextVersionData set to:", this.nextVersionData);
    console.log("[Shells] Version will be:", this.nextVersionData?.Version);

    this.editingShellId = null;
    this.showShellModal = true;
  } catch (err) {
    console.error("[Shells] next-version error:", err);
    alert("Failed to prepare next version.");
  } finally {
    this.showShellLoading = false;
    this.showActionPopup = this.ShellList.map(() => false);
  }
},

    handleOutsideClick() {
      this.showActionPopup = this.ShellList.map(() => false);
    },

    toggleAction(index) {
      const rect = event.currentTarget.getBoundingClientRect();
      this.popupX = rect.right - 140;
      this.popupY = rect.bottom + 4;
      const current = this.showActionPopup[index];
      this.showActionPopup = this.ShellList.map(() => false);
      this.showActionPopup.splice(index, 1, !current);
    },

    previewShell(id) {
      this.editingShellId = id;
      this.showShellPreview = true;
      this.showActionPopup = this.ShellList.map(() => false);
    },

    closeShellModal() {
      this.showShellModal = false;
      this.editingShellId = null;
      this.nextVersionData = null;
      this.GetShellList();
    },

    closeShell() {
      this.showShellPreview = false;
      this.editingShellId = null;
      this.GetShellList();
    },

    async CreateShell() {
      this.editingShellId = null;
      let existingShell =
        this.ShellList.find(shell => shell.IsDefault) ||
        this.ShellList[0] ||
        null;

      if (!existingShell && (this.selectedReportId || this.selectedProgramId)) {
        // Fallback: fetch study-level shells to find a default template to derive from
        const studyId = store.getters.getStudyIs;
        const idtoken = store.getters.getIdToken;
        try {
          const studyUrl = `${this.baseurl}/stats-python/shellconfig/study/${studyId}`;
          const res = await axios.get(studyUrl, {
            headers: { Authorization: "Bearer " + idtoken, "Content-Type": "application/json" }
          });
          const studyShells = this.normalizeShellList(res.data);
          existingShell = studyShells.find(s => s.IsDefault || s.Isdefault || s.isDefault) || studyShells[0] || null;
        } catch (err) {
          console.warn("[Shells] Failed to fetch default study shell for fallback", err);
        }
      }

      if (existingShell && existingShell._id) {
        await this.addNewVersion(existingShell);
        return;
      }

      this.nextVersionData = null;
      this.showShellModal = true;
    },

    SortSelected(property) {
      this.SortProperty = property;
      this.SortOrder = this.SortOrder === 0 ? 1 : 0;
      this.GetShellList();
    },
    shellsClose() {
      const origin = this.$route && this.$route.query ? (Array.isArray(this.$route.query.from) ? this.$route.query.from[0] : this.$route.query.from) : null;
      if (origin === 'tocgenerate') {
        this.$router.push({ path: '/tocgenerate' });
        return;
      }
      if (this.$router && typeof this.$router.go === 'function') {
        this.$router.go(-1);
      } else {
        this.$router.push({ path: '/' });
      }
    },
  },
};
